import { ADMIN, MANAGER } from "../../Constantes/userRoles";
import dashboardIcon from "../../images/desktop-dashboard.svg";
import panelIcon from "../../images/panel-control.svg";
import casesIcon from "../../images/table.svg";
import campaignsIcon from "../../images/message.svg";
import workshopsIcon from "../../images/workshop-car.svg";
import fleetsIcon from "../../images/truck-front.svg";
import customersIcon from "../../images/customer.svg";
import itvsIcon from "../../images/technical-service.svg";

export const ROUTE_PANEL = "/";
export const ROUTE_CASES = "/cases";
export const ROUTE_WORKSHOPS = "/workshops";
export const ROUTE_FLEET = "/fleet";
export const ROUTE_CLIENTS = "/clients";
export const ROUTE_ITVS = "/itv";
export const ROUTE_LOGIN= "/login";
export const ROUTE_DASHBOARD = "/dashboard"
export const ROUTE_CAMPAIGN_STATISTICS = "/campaigns"

export const ROUTE_ADMINS_MENU = "/admin";
export const ROUTE_STATES = "/admin/states";
export const ROUTE_TAXONOMIES = "/admin/taxonomies";
export const ROUTE_ENTRY_CHANNEL = "/admin/entrychannel";
export const ROUTE_ACTION_RESOLUTION = "/admin/actionresolution";
export const ROUTE_INTERACTION = "/admin/interaction";
export const ROUTE_USERS = "/admin/users"
export const ROUTE_EXCEPTIONS = "/admin/exceptions"
export const ROUTE_SUBSTATES = "/admin/subStates"
export const ROUTE_CONTRACT_DATA = "/admin/contractData"
export const ROUTE_TEMPLATES = "/admin/templates"
export const ROUTE_EXTERNAL_USERS = "/admin/externalUsers"
export const ROUTE_ADMIN_WORKSHOPS = "/admin/workshops"
export const ROUTE_ADMIN_FILE_MANAGEMENT = "/admin/fileManagement"
export const ROUTE_ADMIN_CAMPAIGN = "/admin/campaigns"
export const ROUTE_MAIL_MAPPERS = "/admin/mailMappers"
export const ROUTE_SERVICES = "/admin/services"

export const routeList = [
        {path: ROUTE_DASHBOARD, label: "Dashboard", translationMap: "Header.Menu.Dashboard", allowedRoles: [MANAGER, ADMIN], icon: dashboardIcon}, 
        {path: ROUTE_PANEL, label: "Painel", translationMap: "Header.Menu.Panel", allowedRoles: ["*"], icon: panelIcon}, 
        {path: ROUTE_CASES, label: "Casos", translationMap: "Header.Menu.Cases", allowedRoles: ["*"], icon: casesIcon},
        //{path: ROUTE_CAMPAIGN_STATISTICS, label: "Campanhas", translationMap: "Header.Menu.Campaigns", allowedRoles: [MANAGER, ADMIN], icon: campaignsIcon}, 
        // {path: ROUTE_WORKSHOPS, label: "Talleres",  allowedRoles: ["*"], icon: workshopsIcon}, 
        {path: ROUTE_FLEET, label: "Flotas", translationMap: "Vehicles", allowedRoles: ["*"], icon: fleetsIcon}, 
        {path: ROUTE_CLIENTS, label: "Clientes", translationMap: "Header.Menu.Customers", allowedRoles: ["*"], icon: customersIcon},
        // {path: ROUTE_ITVS, label: "ITV", allowedRoles: ["*"], icon: itvsIcon}
];